<template>
  <div class="card card-crypto">
    <div class="card-header d-flex justify-content-between bd-b-0">
      <div>
        <h6 class="mg-b-0">Газрын зураг</h6>
        <p class="tx-13 tx-color-03 mg-b-0"></p>
      </div>

      <nav class="nav nav-row-xs align-items-center">
        <!-- <router-link :to="`/ubtraffic`"
          ><feather type="map"></feather> Замын хөдөлгөөн
          <feather type="chevron-right"></feather
        ></router-link> -->
        <div class="btn-group btn-xs mg-l-auto btn-group-xs">
          <button
            @click="mapMode = 1"
            :class="{ 'btn-primary text-white': mapMode == 1 }"
            class="btn btn-white"
          >
            Зөрчлийн тархац
          </button>
          <button
            @click="mapMode = 2"
            :class="{ 'btn-primary text-white': mapMode == 2 }"
            class="btn btn-white"
          >
            Төхөөрөмжийн байршил
          </button>
        </div>
      </nav>
    </div>
    <div class="card-body pd-0">
      <iframe
        v-if="mapMode == 1"
        src="https://res.gosmart.mn/apps/epheatmap/"
        border="0"
        width="100%"
        style="border:none; height: 65vh;"
      ></iframe>
      <div v-if="mapMode == 2">
        <!-- <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
          <div class="card">
            <div class="card-header">
              <h6 class="mg-b-0">Гэрэл дохио</h6>
            </div>
            <div class="card-body pd-0" v-if="chart1Obj.rdy">
              <div class="row no-gutters">
                <div class="col col-6 col-sm-6 col-xs-6 col-lg">
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Нийт
                        </h6>

                        <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76131)
                              .reduce(
                                (sum, { count }) => sum + parseInt(count),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Хэвийн
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-success"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76131)
                              .reduce(
                                (sum, { count, callCount, noCallWorkCount }) =>
                                  sum +
                                  parseInt(count - callCount - noCallWorkCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Дуудлагатай
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-warning"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76131)
                              .reduce(
                                (sum, { callCount }) =>
                                  sum + parseInt(callCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Засвартай
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-danger"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76131)
                              .reduce(
                                (sum, { workCount }) =>
                                  sum + parseInt(workCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-xs-12 col-md-6 col-lg-6">
          <div class="card">
            <div class="card-header">
              <h6 class="mg-b-0">Хяналтын камер /CCTV/</h6>
            </div>
            <div class="card-body pd-0" v-if="chart1Obj.rdy">
              <div class="row no-gutters">
                <div class="col col-6 col-sm-6 col-xs-6 col-lg">
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Нийт
                        </h6>
                        <h5 class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1">
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76460)
                              .reduce(
                                (sum, { count }) => sum + parseInt(count),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Хэвийн
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-success"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76460)
                              .reduce(
                                (sum, { count, callCount, noCallWorkCount }) =>
                                  sum +
                                  parseInt(count - callCount - noCallWorkCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Дуудлагатай
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-warning"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76460)
                              .reduce(
                                (sum, { callCount }) =>
                                  sum + parseInt(callCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col col-6 col-sm-6 col-xs-6 col-lg bd-sm-t-0 bd-sm-l"
                >
                  <div class="crypto">
                    <div class="media">
                      <div class="media-body pd-20 d-flex align-items-end">
                        <h6
                          class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 mg-b-0"
                        >
                          Засвартай
                        </h6>
                        <h5
                          class="tx-normal tx-rubik mg-b-0 mg-l-auto lh-1 tx-danger"
                        >
                          {{
                            chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76460)
                              .reduce(
                                (sum, { workCount }) =>
                                  sum + parseInt(workCount),
                                0
                              )
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <apexchart
          type="bar"
          height="160"
          :options="chartOptions"
          :series="series"
          :key="chartKey"
        ></apexchart>
        <GmapMap
          :center="{ lat: 47.9138932, lng: 106.8986408 }"
          :zoom="13"
          map-type-id="roadmap"
          labels="off"
          style="width: 100%; height: 65vh"
          ref="map"
        >
          <!-- <GmapCluster> -->
          <GmapInfoWindow
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          ></GmapInfoWindow>
          <GmapMarker
            style="color: green"
            :icon="`${myResBaseUrl}apps/asset/${m.icon}.png?w=24`"
            @click="toggleInfoWindow(m, i)"
            v-for="(m, i) in googleMapMaker"
            :key="i"
            :position="m.position"
            :title="m.title"
          />
        </GmapMap>
      </div>
    </div>
    <b-modal v-model="infMdl.modal" :title="infMdl.title" size="xl">
      <div v-if="infMdl.siteInfo != null">
        <!-- {{infMdl.siteInfo}} -->
        <ul class="list-unstyled lh-7">
          <li class="d-flex justify-content-between">
            <span>Тоног төхөөрөмж</span>
            <span>{{ infMdl.siteInfo.deviceData.device.deviceName }}</span>
          </li>
          <li
            class="d-flex justify-content-between"
            v-if="infMdl.siteInfo.deviceData.device.type != null"
          >
            <span>Төрөл</span>
            <span>{{ infMdl.siteInfo.deviceData.device.type.name }}</span>
          </li>
          <li class="d-flex justify-content-between">
            <span>Суурилуулсан огноо</span>
            <span>{{
              infMdl.siteInfo.deviceData.device.dueStartDate
                | moment("YYYY-MM-DD")
            }}</span>
          </li>

          <li class="d-flex justify-content-between">
            <span>Ашиглалт дуусах хугацаа</span>
            <span>{{
              infMdl.siteInfo.deviceData.device.dueDate | moment("YYYY-MM-DD")
            }}</span>
          </li>
        </ul>

        <div class="card ht-lg-100p">
          <div
            class="
                  card-header
                  d-flex
                  align-items-center
                  justify-content-between
                "
          >
            <h6 class="mg-b-0">Дуудлагын түүх</h6>
          </div>
          <div class="card-body pd-0">
            <div v-if="infMdl.siteInfo.cmmsCalls.length > 0">
              <div class="table-responsive">
                <table class="table table-dashboard mg-b-0 bd-t-0 tx-13">
                  <thead>
                    <tr>
                      <th>Хаагдсан эсэх</th>
                      <th>Код</th>
                      <th>Шалтгаан</th>
                      <th>Товч тайлбар</th>
                      <th>Үүсгэсэн</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(call, ci) in infMdl.siteInfo.cmmsCalls"
                      :key="`cll` + ci"
                    >
                      <td style="width: 180px">
                        <template v-if="call.isCompleted"
                          ><feather
                            type="check-square"
                            class="text-success"
                          ></feather>
                        </template>
                        <template v-else
                          ><feather type="square" class="text-danger"></feather>
                        </template>
                        <!-- {{ call.isCompleted == true ? "тийм" : "үгүй" }} -->
                      </td>
                      <td style="width: 180px">{{ call.code }}</td>
                      <td style="width: 240px">
                        {{ call.reason.name }}
                      </td>
                      <td style="width: 240px">
                        {{ call.shortInfo.name }}
                      </td>
                      <td>
                        {{ call.createdDate | moment("YYYY-MM-DD HH:mm") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="pd-10 text-center">
              Дуудлагын түүх бүртгэгдээгүй байна.
            </div>
          </div>
        </div>

        <div class="card ht-lg-100p mg-t-20">
          <div
            class="
                  card-header
                  d-flex
                  align-items-center
                  justify-content-between
                "
          >
            <h6 class="mg-b-0">Засвар үйлчилгээний түүх</h6>
          </div>
          <div class="card-body pd-0">
            <div v-if="infMdl.siteInfo.workOrders.length > 0">
              <div class="table-responsive">
                <table class="table mg-b-0 bd-t-0 table-dashboard tx-13">
                  <thead>
                    <tr>
                      <th>Хаагдсан эсэх</th>
                      <th>Код</th>
                      <th>Ангилал</th>
                      <th>Төлөв</th>
                      <th>Үүсгэсэн</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(work, wi) in infMdl.siteInfo.workOrders"
                      :key="`wrk` + wi"
                    >
                      <td style="width: 180px">
                        <template v-if="work.isCompleted"
                          ><feather
                            type="check-square"
                            class="text-success"
                          ></feather>
                        </template>
                        <template v-else
                          ><feather type="square" class="text-danger"></feather>
                        </template>
                      </td>
                      <td style="width: 180px">{{ work.code }}</td>
                      <td style="width: 240px">
                        {{ work.type.name }}
                      </td>
                      <td style="width: 240px">
                        {{ work.source.name }}
                      </td>
                      <td>
                        {{ work.createdDate | moment("YYYY-MM-DD HH:mm") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="pd-10 text-center">
              Засвар үйлчилгээний түүх бүртгэгдээгүй байна.
            </div>
          </div>
        </div>

        <!-- {{ deviceModal.siteInfo }} -->
      </div>
    </b-modal>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      chartKey: 0,
      chart1Obj: {
        rdy: false,
        flat: null,
      },
      myResBaseUrl: "https://res.gosmart.mn/",
      mapMode: 2,
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      assets: {
        cctv: {
          allCount: null,
          count: null,
        },
        penaltyCamera: {
          allCount: null,
          count: null,
        },
        signal: {
          allCount: null,
          count: null,
        },
      },
      googleMapMaker: [],

      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infMdl: {
        modal: false,
        title: "",
        siteInfo: null,
      },

      series: [
        {
          name: "Хэвийн",
          data: [0, 0],
        },
        {
          name: "Дуудлагатай",
          data: [0, 0],
        },
        {
          name: "Засвартай",
          data: [0, 0],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: ["Гэрэл дохио", "Хяналтын камер /CCTV/"],
          labels: {
            formatter: function(val) {
              return val + "";
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + "";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    //this.loadPenaltyPaidData();
    this.loadMap();
    this.loadAssets();
  },
  methods: {
    toggleInfoWindow(marker, idx) {
      // console.log('mark', marker);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "TrafficData/AssetSiteInfo" },
        params: {
          siteId: marker.deviceId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.infMdl.siteInfo = res.data;
      });
      this.infMdl.title = marker.title;
      this.infMdl.modal = true;
    },
    loadMap() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "trafficData/AssetDashboardData" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          this.chart1Obj.flat = res.data;
          this.series[0].data[0] = this.chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76131)
                              .reduce(
                                (sum, { count, callCount, noCallWorkCount }) =>
                                  sum +
                                  parseInt(count - callCount - noCallWorkCount),
                                0
                              );

          this.series[0].data[1] = this.chart1Obj.flat.asset.groupedByType
                              .filter((x) => x.typeId == 76460)
                              .reduce(
                                (sum, { count, callCount, noCallWorkCount }) =>
                                  sum +
                                  parseInt(count - callCount - noCallWorkCount),
                                0
                              );

          this.series[1].data[0] = this.chart1Obj.flat.asset.groupedByType
            .filter((x) => x.typeId == 76131)
            .reduce((sum, { callCount }) => sum + parseInt(callCount), 0);

          this.series[1].data[1] = this.chart1Obj.flat.asset.groupedByType
            .filter((x) => x.typeId == 76460)
            .reduce((sum, { callCount }) => sum + parseInt(callCount), 0);

          this.series[2].data[0] = this.chart1Obj.flat.asset.groupedByType
            .filter((x) => x.typeId == 76131)
            .reduce((sum, { workCount }) => sum + parseInt(workCount), 0);

          this.series[2].data[1] = this.chart1Obj.flat.asset.groupedByType
            .filter((x) => x.typeId == 76460)
            .reduce((sum, { workCount }) => sum + parseInt(workCount), 0);
          this.chartKey++;
          this.chart1Obj.rdy = true;
          this.googleMapMaker = res.data.mapData.sites
            .filter(
              (t) =>
                t.device.location.lat != null && t.device.location.lng != null
            )
            .map((x) => {
              //console.log(`${x.device.type.code}-${x.mapFlag.color}`);
              return {
                id:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
                title: x.device.deviceName,
                info:
                  x.ticket != undefined && x.ticket != null
                    ? `
                <h4>${moment(x.ticket.createdDate).format(
                  "YYоны MM-р сар DD. HHц:mmм"
                )}</h4>
                <ul class="list-group wd-500">
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.task
                      }</h6>
                      <span class="d-block tx-11 text-muted">товч утга</span>
                    </div>
                  </li>
                  <li class="list-group-item active d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-white tx-semibold mg-b-0">${
                        x.device.deviceName
                      }</h6>
                      <span class="d-block tx-11 text-white">төхөөрөмж</span>
                    </div>
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.type.name
                      }</h6>
                      <span class="d-block tx-11 text-muted">ангилал</span>
                    </div>
                  </li>
                  
                </ul>
          `
                    : "",
                // <li class="list-group-item d-flex align-items-center">
                //           <a @click="${this.showDetail(x)}">Дэлгэрэнгүй</a>
                //         </li>
                position: {
                  lat: parseFloat(x.device.location.lat),
                  lng: parseFloat(x.device.location.lng),
                },
                icon: `${x.device.deviceType.code}-${x.mapFlag.color}`,
                color: x.mapFlag.color,
                deviceId: x.device.id,
                firstDeviceId: x.firstDeviceId,
                ticketId:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
              };
            });
        }
      });
    },
    loadAssets() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "trafficData/AssetData" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.assets = res.data.asset;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>
